function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import zbDialog from '@/components/zbDialog';
import zbSetConditions from '@/components/zbSetConditions';
import conditionDialog from '@/components/develop/conditionDialog';
import { viewSearchApi } from '@/api/develop';
export default {
  name: 'setChartFilter-editor',
  components: {
    zbDialog: zbDialog,
    zbSetConditions: zbSetConditions,
    conditionDialog: conditionDialog
  },
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  data: function data() {
    return {
      cutOption: {},
      conditionConf: {},
      viewSearch: [],
      dialogIsShow: false,
      setConditionText: ''
    };
  },
  computed: _objectSpread({}, mapState({
    allEntityName: function allEntityName(state) {
      return state.common.allEntityName;
    }
  })),
  watch: {
    optionModel: {
      handler: function handler(newVal, oldVal) {
        this.cutOption = newVal;
        if (newVal.setChartFilter.list && newVal.setChartFilter.list.length > 0) {
          var filterArr = [];
          newVal.setChartFilter.list.map(function (item) {
            filterArr.push(item.obj);
          });
          var data = {
            list: filterArr,
            type: '',
            additional_search_boolean: newVal.setChartFilter.additional_search_boolean || '0'
          };
          this.$store.commit('uadatefieldOptions', data);
        } else {
          var _data = {
            list: [],
            type: '',
            additional_search_boolean: '0'
          };
          this.$store.commit('uadatefieldOptions', _data);
        }
        this.getSetConditionText();
        if (newVal.dataEntity && !this.viewSearch.length) {
          this.getvalue(newVal.dataEntity);
        }
      },
      deep: true,
      immediate: true
    }
    // 'optionModel.dataEntity': {
    //   handler(newVal) {
    //     if (this.optionModel.name === this.cutOption.name) {
    //       this.cutOption.setChartFilter = {
    //         equation: '',
    //         items: []
    //       }
    //       this.getSetConditionText()
    //     }
    //   },
    //   immediate: true
    // }
  },
  mounted: function mounted() {
    this.cutOption = this.optionModel;
    this.getSetConditionText();
  },
  methods: {
    // 获取过滤条件数据
    getvalue: function getvalue(id) {
      var _this = this;
      viewSearchApi(id).then(function (res) {
        if (res.status === 200) {
          _this.viewSearch = res.data;
        }
      });
    },
    updateConditionDialog: function updateConditionDialog() {
      this.dialogIsShow = false;
    },
    setCondition: function setCondition() {
      if (!this.optionModel.dataEntity) {
        this.$message.warning('请先选择图标数据实体');
        return;
      }
      var actionFilter = this.initFilter(_objectSpread({}, this.cutOption.setChartFilter));
      this.conditionConf = JSON.parse(JSON.stringify(actionFilter));
      this.dialogIsShow = true;
    },
    initFilter: function initFilter(filter) {
      var equation = filter.equation;
      if (!equation || equation === '') {
        filter.type = 1;
        filter.equation = '';
      } else if (equation === '1') {
        filter.type = 2;
        filter.equation = '1';
      } else {
        filter.type = 3;
      }
      return filter;
    },
    getSetConditionText: function getSetConditionText() {
      var actionFilter = _objectSpread({}, this.cutOption.setChartFilter);
      var length = actionFilter && actionFilter.list ? actionFilter.list.length : 0;
      this.setConditionText = length > 0 ? "\u5DF2\u8BBE\u7F6E\u6761\u4EF6\uFF08".concat(length, "\uFF09") : '点击设置';
    },
    conditionConfirm: function conditionConfirm(e) {
      this.cutOption.setChartFilter = Object.assign({}, e);
      this.dialogIsShow = false;
      this.$emit('update:optionModel', this.cutOption);
    }
  }
};